import superagent from 'superagent'

export const huntPlannerActiveOtions = payload => ({
    type: 'HUNT_PLANNER_ACTIVE_SELECTED_OPTIONS',
    payload: payload
})
